<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'teamList' }">{{$t('entities.team.plural')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'teamShow', params: { id: model.id } }" v-if="model">{{ model.name }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('table.history')}}</el-breadcrumb-item>    </el-breadcrumb>

    <h2 class="page-title"> {{$t('entities.team.singular')}} history</h2>

    <el-form @submit.native.prevent class="search" :inline="true">
      <el-form-item>
        <el-input v-model="pager.search" :placeholder="$t('table.search')">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <el-table
      :data="pager.paginate(list)"
      :default-sort="{
        prop: 'modified',
        order: 'descending'
      }"
      empty-text="There is no history yet"
      @sort-change="(args) => pager.sortChange(args)"
      style="width: 100%"
      v-loading="loading"
      border
    >
      <el-table-column
        prop="modified"
        label="Updated at"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.modified | formatDatetime }}
        </template>
      </el-table-column>

      <el-table-column
        label="Updated by"
        prop="modifiedBy.email"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="name"
        label="Name"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="category"
        label="Category"
      >
        <template slot-scope="scope">
          {{ scope.row.category ? scope.row.category.label : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="club"
        label="Club"
      >
        <template slot-scope="scope">
          {{ scope.row.club ? scope.row.club.name : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="locality"
        label="Locality"
        sortable="custom"
      ></el-table-column>

      <!-- <el-table-column
        prop="players"
        label="Players"
      >
        <template slot-scope="scope">
          <div
            v-for="players in scope.row.players"
            :key="players.id"
          >
            {{ players.label }}
          </div>
        </template>
      </el-table-column> -->

      <el-table-column
        prop="country"
        label="Country"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="web"
        label="Web"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="created"
        label="Created at"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.created | formatDatetime }}
        </template>
      </el-table-column>

      <el-table-column
        label="Created by"
        prop="createdBy.email"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="deleted"
        label="Deleted at"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.deleted | formatDatetime }}
        </template>
      </el-table-column>

      <el-table-column
        label="Deleted by"
        prop="deletedBy.email"
        sortable="custom"
      ></el-table-column>
    </el-table>

    <div class="mt-3">
      <el-pagination
        style="float: right"
        @size-change="(args) => pager.pageSizeChange(args)"
        :current-page.sync="pager.currentPage"
        :layout="paginationLayout"
        :total="pager.filteredAndSortedList(list).length"
        background
      ></el-pagination>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-team-history-single',

  props: {
    id: String,
  },

  computed: {
    ...mapGetters({
      loading: 'entities/team/historySingle/loading',
      list: 'entities/team/historySingle/list',
      pager: 'entities/team/historySingle/pager',
      model: 'entities/team/historySingle/model',
      paginationLayout: "shared/paginationLayout"
    }),
  },

  created() {
    this.$store.dispatch(
      'entities/team/historySingle/setup',
      this.id,
    );
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch(
      'entities/team/historySingle/clear',
    );
    next();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/team/team-history/team-history-single/team-history-single.vue?12cbbfb1